export const SELLER_SESSION_EXPIRED_CODE = "SELLER_SESSION_EXPIRED";

export type SellerSessionFailureKind = "expired" | "invalid" | null;

export function getSellerLoginUrl(locale: string, _storeSlug?: string | null) {
  void _storeSlug;
  return `/${locale}/login`;
}

export function classifySellerSessionFailure(
  status: number,
  errorCode?: string | null,
): SellerSessionFailureKind {
  if (status !== 401 && status !== 403) {
    return null;
  }

  if (errorCode === SELLER_SESSION_EXPIRED_CODE) {
    return "expired";
  }

  return "invalid";
}
